const COMMON = "common";
const CUSTOMER = "customer";

export const ENTITLEMENT_CONFIG_TYPE = {
  COMMON,
  CUSTOMER
};
